import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noFieldSelectedError: {
		id: 'business-issue-field-statistics.statistics-sidebar.no-field-selected-error',
		defaultMessage:
			"We can't show this chart because it uses one of your hidden fields. Select a different field from the dropdown.",
		description: 'Error message when the user tries to show a chart for a hidden field',
	},
});
